export default "__VITE_ASSET__BqbcNIzg__"